(function () {
  function init(root) {
    var pills = root.querySelectorAll('[data-td-pill], [data-td-pill-all]');
    var clearBtn = root.querySelector('[data-td-clear]');
    var multi = root.getAttribute('data-multi-select') === 'true';

    function activeTags() {
      var out = [];
      pills.forEach(function (p) {
        if (p.hasAttribute('data-td-pill-all')) return;
        if (p.classList.contains('is-active')) {
          out.push(p.getAttribute('data-td-pill'));
        }
      });
      return out;
    }

    function setAllActive(allActive) {
      pills.forEach(function (p) {
        if (p.hasAttribute('data-td-pill-all')) {
          p.classList.toggle('is-active', allActive);
        } else if (allActive) {
          p.classList.remove('is-active');
        }
      });
    }

    function applyFilter() {
      var tags = activeTags();
      var hasActive = tags.length > 0;

      if (!hasActive) setAllActive(true);

      // Find every promo card on the page (across multiple grids if present)
      var cards = document.querySelectorAll('.td-promo-card[data-tags]');
      var anyVisible = false;
      cards.forEach(function (card) {
        var cardTags = (card.getAttribute('data-tags') || '').split(',').map(function (s) { return s.trim(); });
        var visible = !hasActive || tags.every(function (t) { return cardTags.indexOf(t) !== -1; });
        card.style.display = visible ? '' : 'none';
        if (visible) anyVisible = true;
      });

      // Toggle the empty-state message in each promo grid
      document.querySelectorAll('[data-td-promo-grid]').forEach(function (grid) {
        var empty = grid.querySelector('[data-td-empty]');
        if (!empty) return;
        var gridCards = grid.querySelectorAll('.td-promo-card[data-tags]');
        var anyInGrid = false;
        gridCards.forEach(function (c) { if (c.style.display !== 'none') anyInGrid = true; });
        empty.hidden = anyInGrid;
      });

      if (clearBtn) clearBtn.hidden = !hasActive;
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.hasAttribute('data-td-pill-all')) {
          // Clear all filter pills, mark "All" active
          pills.forEach(function (p) {
            if (!p.hasAttribute('data-td-pill-all')) p.classList.remove('is-active');
          });
          setAllActive(true);
        } else {
          if (multi) {
            pill.classList.toggle('is-active');
          } else {
            pills.forEach(function (p) {
              if (!p.hasAttribute('data-td-pill-all') && p !== pill) p.classList.remove('is-active');
            });
            pill.classList.toggle('is-active');
          }
          setAllActive(activeTags().length === 0);
        }
        applyFilter();
      });
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        pills.forEach(function (p) {
          if (!p.hasAttribute('data-td-pill-all')) p.classList.remove('is-active');
        });
        setAllActive(true);
        applyFilter();
      });
    }

    applyFilter();
  }

  function bootstrap() {
    document.querySelectorAll('[data-td-filter]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();